module.exports = __webpack_public_path__ + "static/media/sketch.68cdfcd6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mozilla/SketchPlugin/sketch.gif
// module id = ./src/assets/Mozilla/SketchPlugin/sketch.gif
// module chunks = 0